import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';


import ManqueColisStep from './ManqueColisStep';
import { CodeDepot } from 'constants.js';

class ManqueColisStepContainer extends React.Component {

    render() {
        return (
            <ManqueColisStep {...this.props} />
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    let lignesUniquement = false;
    let autoriseChoixLigne = true;

    let piece = state.pieceGestion[ownProps.namespace].piecesGestion ? state.pieceGestion[ownProps.namespace].piecesGestion.items.find(p => p.numeroPiece === ownProps.reclamation.numeroPiece) : null;

    if (piece) {
        lignesUniquement = piece.codeDepot === CodeDepot.PlateformeVaulx;
        autoriseChoixLigne = piece.codeDepot !== CodeDepot.PlateformeMonne;
    }

    if (!autoriseChoixLigne) {
        ownProps.reclamation.ligneOuColis = 'colis'
    }

    return {
        lignesUniquement: lignesUniquement,
        autoriseChoixLigne: autoriseChoixLigne
    };
};

ManqueColisStepContainer.propTypes = {
    reclamation: PropTypes.object.isRequired,
    namespace: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(ManqueColisStepContainer);